import ActivityLogs from "../../Dashboard/ActivityLogs";

export default function Index() {
  return (
    <div className="w-full p-8 ">
      <ActivityLogs />
    </div>
  )
}